export default __webpack_public_path__ + "static/media/share-pink-16px.ca8bc42c.svg";